import useResource from './useResource';

const useCostItems = () => {
	const RESOURCE_URL = '/api/v1/admin/cost-items';

	const {
		isLoading,
		isEmpty,
		isEditing,
		resource: costItem,
		resources: costItems,
		findOne: findCostItem,
		findMany: findCostItems,
		update: updateCostItem,
		create: createCostItem,
		save: saveCostItem,
		destroy: deleteCostItem,
		handleChange,
		reloadMany: reloadCostItems,
		reloadOne: reloadCostItem
	} = useResource({
		id: null,
		url: RESOURCE_URL,
		name: 'cost_item'
	});

	return {
		isLoading,
		isEmpty,
		isEditing,
		costItem,
		costItems,
		findCostItem,
		findCostItems,
		updateCostItem,
		createCostItem,
		saveCostItem,
		deleteCostItem,
		handleChange,
		reloadCostItems,
		reloadCostItem
	};
};

export default useCostItems;
